export const APP_NAME = import.meta.env.VITE_APP_NAME || 'AI Ark';
export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;
export const SOCKET_BASE_URL = import.meta.env.VITE_SOCKET_BASE_URL;
export const LOG_API_CALL_DURATION_ENABLE =
  import.meta.env.VITE_LOG_API_CALL_DURATION_ENABLE === 'true';
export const ENRICHMENT_BROWSE_TABLE_SIZE = 10;
